import React, { useEffect, useState } from 'react'
import './App.css'
import { Redirect, useHistory, useLocation } from 'react-router-dom'
import { IoIosArrowBack } from 'react-icons/io'
import { BiMenu } from 'react-icons/bi'
import RefundRules from './components/refunds/RefundRules'
import RefundRequests from './components/refunds/RefundRequests'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'

// Match these to your SideNav CSS widths
const SIDEBAR_WIDTH = 240
const SIDEBAR_COLLAPSED_WIDTH = 72

const RefundView = () => {
  const history = useHistory()
  const location = useLocation()
  const { eventid, eventname, is_sponsorship } = location.state || {}

  const [isMob, setIsMob] = useState(window.innerWidth <= 768)
  const [collapsed, setCollapsed] = useState(window.innerWidth <= 768)

  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth <= 768
      setIsMob(mobile)
      setCollapsed((prev) => (mobile ? true : prev))
    }
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  const handleToggle = () => setCollapsed((prev) => !prev)

  if (localStorage.getItem('businessid') === null) {
    return <Redirect to="/login" />
  }

  const sidebarOffset = isMob ? 0 : collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH

  return (
    <div className="view mt-5">
      <Header />
      <SideNav collapsed={collapsed} onToggle={handleToggle} />

      {isMob && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}
      {isMob && collapsed && (
        <label className="mobile-toggle" onClick={handleToggle}>
          <BiMenu size={25} />
        </label>
      )}

      <div
        className="containe pl-1 pr-1"
        style={{
          marginLeft: sidebarOffset,
          width: `calc(100% - ${sidebarOffset}px)`,
          transition: 'margin-left .25s ease, width .25s ease',
        }}
      >
        <div className="row justify-content-center just-container-insid">
          <div className="col-lg-12 mt-5 mb-4">
            {is_sponsorship == true ? (
              <div className="sponsored-badge w-100 p-2 text-center" style={{ fontSize: 16 }}>
                🌟 Tickets to this event are proudly sponsored by Karamale.
              </div>
            ) : (
              ''
            )}
          </div>

          <div className="col-lg-12">
            <div className="col-12 mb-2 text-right">
              <span className="cursor-pointer" onClick={() => history.goBack()}>
                <IoIosArrowBack size={25} /> Back
              </span>
            </div>

            <div className="BoxDashboardContainer mb-4 pb-3 pl-3 pr-3">
              <div className="row justify-content-center w-100">
                <label className="mb-3 text-left w-100">
                  <h5>{eventname}</h5>
                </label>

                <div className="col-12 p-0">
                  <RefundRules eventid={eventid} />
                </div>
                <div className="col-12 p-0">
                  <RefundRequests eventid={eventid} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RefundView
